import React from 'react'
import PrimaryButton from '../Button/PrimaryButton'

const ConfirmModal = ({ open, onClose, onConfirm, isLoading }) => {
  if (isLoading) {
    return (
      <div className={`modal ${open && 'modal-open'}`}>
        <div className="modal-box relative">Tunggu Sebentar...</div>
      </div>
    )
  }

  return (
    <div className={`modal ${open && 'modal-open'}`}>
      <div className="modal-box relative">
        <h1 className="text-xl font-semibold">Detail KTA sudah benar?</h1>
        <p className="my-4">
          Data yang kamu berikan, tidak akan bisa diubah kembali dan akan
          digunakan untuk detail di KTA Jakmania. Kamu yakin ingin lanjut
        </p>
        <div className="flex justify-end items-center gap-2">
          <PrimaryButton onClick={onClose}>Pastikan Kembali</PrimaryButton>
          <PrimaryButton onClick={onConfirm}>Ya, Simpan</PrimaryButton>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
